import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./globals.css";
import App from "./App.jsx";
import ErrorFallback from "./components/ErrorFallback.jsx";
import { initSentry } from "./sentry.js";

initSentry();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
